import { Injectable, computed, signal } from '@angular/core';
import { ScrollConfig } from '@app-types/api/email';
import { EMAILS_SETTINGS } from '@app-shared/constants/constants';
import { InfinityScrollComponent } from '@app-components/common/infinity-scroll/infinity-scroll.component';
import { InfiniteScrollService } from '@app-services/infinite-scroll.service';

const { PAGE_SIZE, STEP_FETCH } = EMAILS_SETTINGS;

@Injectable({
  providedIn: 'root',
})
export class EmailsScrollService {
  emailsDesktopInfinityScroll: InfinityScrollComponent;
  emailsMobileInfinityScroll: InfinityScrollComponent;

  stepFetch = STEP_FETCH;
  pageSize = PAGE_SIZE;

  initState = {
    offset: 0,
    isErrorScroll: false,
    isLoadingScroll: false,
    canNavigateForward: false,
  };
  scrollConfig = signal<ScrollConfig>({ ...this.initState });

  readonly offset = computed(() => this.scrollConfig().offset);
  readonly isErrorScroll = computed(() => this.scrollConfig().isErrorScroll);
  readonly isLoadingScroll = computed(
    () => this.scrollConfig().isLoadingScroll
  );
  readonly canNavigateForward = computed(
    () => this.scrollConfig().canNavigateForward
  );

  constructor(private scrollService: InfiniteScrollService) {}

  updateScrollConfig(scrollConfig: Partial<ScrollConfig>): void {
    this.scrollConfig.update(prev => ({
      ...prev,
      ...scrollConfig,
    }));
  }

  resetScrollConfig(): void {
    this.scrollConfig.set({ ...this.initState });
  }

  setNextOffset(): void {
    this.scrollConfig.update(prev => ({
      ...prev,
      offset: prev.offset + this.pageSize,
    }));
  }

  scrollToTop(): void {
    this.emailsDesktopInfinityScroll?.scrollTop();
    this.emailsMobileInfinityScroll?.scrollTop();
  }

  reconnect(): void {
    this.emailsDesktopInfinityScroll?.reconnect();
    this.emailsMobileInfinityScroll?.reconnect();
  }

  resetOffset(): void {
    this.scrollConfig.update(prev => ({
      ...prev,
      offset: 0,
    }));
  }

  resetScroll(): void {
    this.scrollService.reset();
  }
}
